import React from 'react';
import { EditItem } from '..';
import { useEffect } from 'react';
import { INavigableComponent } from '../../../../interfaces';
import { ToolbarContextEnum } from '../../../../enums';
import { ISubscriptionTiers } from '../../types';

interface ItemPageProps {
  config: any;
  data: ISubscriptionTiers;
}

export default function ItemPage({
  config,
  data,
  setToolbarConfig
}: ItemPageProps & INavigableComponent) {
  const mode = 'edit';
  const SelectedComponent = <EditItem data={data} />;

  useEffect(() => {
    let context = ToolbarContextEnum.EditItem;
    setToolbarConfig?.({ ...config, context, item: data });
  }, [config, data, mode, setToolbarConfig]);

  return SelectedComponent;
}
